import React from 'react';
import { NavLink, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Proofs from './pages/Proofs';
import Records from './pages/Records';
import Reputation from './pages/Reputation';
import WalletButton from './components/WalletButton';
import './styles/ledger.css';

const navItems = [
  { to: '/', label: '📊 Dashboard', end: true },
  { to: '/proofs', label: '📝 Proof Submit' },
  { to: '/records', label: '📋 Records' },
  { to: '/reputation', label: '⭐ Reputation' },
];

export default function App() {
  return (
    <Router>
      <div className="ledger-app">
        <header className="ledger-topbar">
          <div className="ledger-topbar-inner">
            <div className="ledger-brand">
              <span className="ledger-brand-icon">📒</span>
              <span className="ledger-brand-text">AGENTUMI Ledger</span>
            </div>
            <nav className="ledger-nav">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `ledger-nav-link${isActive ? ' active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div className="ledger-nav-actions">
              <a href="https://market.agentumi.xyz" className="ledger-external-link" target="_blank" rel="noopener noreferrer">
                Market →
              </a>
              <WalletButton />
            </div>
          </div>
        </header>
        <main className="ledger-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/proofs" element={<Proofs />} />
            <Route path="/records" element={<Records />} />
            <Route path="/reputation" element={<Reputation />} />
          </Routes>
        </main>
        <footer className="ledger-footer">
          <div className="ledger-footer-inner">
            <div className="ledger-footer-brand">
              <span>📒</span> AGENTUMI Ledger — Proof & Reputation Trust System
            </div>
            <div className="ledger-footer-links">
              <a href="https://market.agentumi.xyz" target="_blank" rel="noopener noreferrer">Market</a>
              <a href="https://agu.agentumi.xyz" target="_blank" rel="noopener noreferrer">AGU</a>
              <a href="https://finance.agentumi.xyz" target="_blank" rel="noopener noreferrer">Finance</a>
              <a href="https://insurance.agentumi.xyz" target="_blank" rel="noopener noreferrer">Insurance</a>
              <a href="https://doc.agentumi.xyz" target="_blank" rel="noopener noreferrer">Docs</a>
              <a href="https://github.com/softkid/agentumi" target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
            <div className="ledger-footer-copy">© 2026 AGENTUMI • Blockchain-based Transparent Verification</div>
          </div>
        </footer>
      </div>
    </Router>
  );
}
